export enum SchoolActions {
  SET_SCHOOL = "SET_SCHOOL",
  SELECT_FACULTY = "SELECT_FACULTY",
  SELECT_DEPARTMENT = "SELECT_DEPARTMENT",
  SELECT_PROGRAM = "SELECT_PROGRAM",
  SELECT_ORIENTATION = "SELECT_ORIENTATION",
  TOGGLE_POPUP = "IS_POPUP_OPEN",
}
